// Le compteur de vies : combien de parties ont commencé, dans ce navigateur et chez l'ensemble des joueurs.
// Le total mondial passe par un petit service à déployer une fois (voir serveur/compteur-vies/README.md) :
// tant que son adresse est vide, le jeu ne fait aucun appel réseau, comme avant.
export const COUNTER_URL = 'https://carnet-vies.alex-guenat.workers.dev';

import { STORAGE_PREFIX, reprendreAnciennesCles } from './stockage';

/** Le compte local vit à côté des sauvegardes : « Recommencer une vie » ne l'efface pas. */
const LIVES_KEY = `${STORAGE_PREFIX}vies`;

export function livesInBrowser(): number {
  reprendreAnciennesCles();
  try {
    return Number(localStorage.getItem(LIVES_KEY)) || 0;
  } catch {
    return 0;
  }
}

/** Une vie commence (le cadeau de Suzanne est ouvert) : +1 ici, et +1 au compteur mondial s'il existe. */
export function recordLife(): void {
  try {
    localStorage.setItem(LIVES_KEY, String(livesInBrowser() + 1));
  } catch {
    // Stockage indisponible : tant pis pour le compte local.
  }
  // Seulement depuis un navigateur : les tests et les robots (Node a fetch) ne comptent pas.
  if (!COUNTER_URL || typeof document === 'undefined') return;
  try {
    // Un simple signal anonyme, sans attendre la réponse ; une panne du compteur ne gêne jamais le jeu.
    void fetch(`${COUNTER_URL}/vie`, { method: 'POST' }).catch(() => undefined);
  } catch {
    // fetch indisponible (tests hors navigateur).
  }
}

/** Le total mondial, ou null sans adresse renseignée, hors ligne, ou si le service ne répond pas. */
export async function fetchGlobalLives(): Promise<number | null> {
  if (!COUNTER_URL || typeof document === 'undefined') return null;
  try {
    const response = await fetch(`${COUNTER_URL}/total`);
    const data = (await response.json()) as { total?: number };
    return typeof data.total === 'number' ? data.total : null;
  } catch {
    return null;
  }
}
